import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { UserDto } from '@cutlyft/zod-schemas';
import { apiClient } from '@/lib/api-client';
import { queryKeys } from '@/lib/query-keys';

interface DeactivateUserApiResponse {
  success: boolean;
  data: UserDto;
}

/**
 * Mutation hook for deactivating a user.
 * Calls POST /users/:id/deactivate.
 */
export function useDeactivateUser() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (id: number) => {
      const response = await apiClient.post<DeactivateUserApiResponse>(`/users/${id}/deactivate`);
      return response.data.data;
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: queryKeys.users.list() });
      queryClient.invalidateQueries({ queryKey: queryKeys.users.byId(data.id) });
    },
  });
}
